import { Link } from "react-router-dom";
import { CheckCircle2, Phone } from "lucide-react";
import { Button } from "@/components/ui/button";
import { site, telephoneHref } from "@/lib/site";
import { Helmet } from "react-helmet-async";

const ThankYou = () => (
  <section className="py-20 md:py-28">
    <Helmet><title>Thank You | {site.shortName}</title><meta name="robots" content="noindex, follow" /></Helmet>
    <div className="container max-w-xl text-center">
      <CheckCircle2 className="mx-auto mb-6 h-16 w-16 text-secondary" />
      <h1 className="mb-4 text-3xl font-heading font-bold">Thank you for your request.</h1>
      <p className="mb-8 text-muted-foreground">Your project details have been received. We’ll review them and follow up using your preferred contact method.</p>
      <div className="flex flex-col justify-center gap-3 sm:flex-row">
        <Button asChild><Link to="/">Return Home</Link></Button>
        <Button variant="outline" asChild><a href={telephoneHref}><Phone className="mr-2 h-4 w-4" />Call {site.phone}</a></Button>
      </div>
    </div>
  </section>
);

export default ThankYou;
